import React from 'react';
import Table from './table/Table';
import styled from 'styled-components';
import { FADE, t } from 'theme';
const debug = require('debug')('components:CityStatus');

// Styled components for layout and background
const StatusContainer = styled.div`
  display: flex;
  justify-content: center; // Centers the child components horizontally
  align-items: flex-start;
  gap: 20px; // Adds space between the child components
  padding: 20px 0;
  margin: auto; // Centers the container
  max-width: 90%; // Limits the maximum width and ensures some margin from the screen edges
  flex-wrap: wrap;
`;

// No surface of its own — the tables read off the page like everything else, so they follow
// whichever palette is up.
const StatusBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; // Centers the text and meter vertically
  color: ${t('fg')};
  transition: color ${FADE};
`;

// The label is just 'prices'. Grading them 'Fair' would say what 'a price is named once and it
// holds' already said on the page above, and the numbers let the player grade a town themselves.
const marketData = prices => {
  const priceData = Object.entries(prices).map(([item, price]) => ({
    label: item,
    value: price
  }));
  return { priceData, marketLabel: 'prices' };
};

// Attitude, generosity and standing are all carried by the arrival lines on the city page.
// Naming them here too would be the same fact stated twice, once as a word and once as a label.
const statusData = city => {
  const statusLabel = 'clout';
  const townData = [
    { label: 'influence', value: city.influence },
    { label: 'fear', value: city.intimidation },
    { label: 'respect', value: city.respect }
  ];

  return { townData, statusLabel };
};

const CityStatus = ({ prices, showStatusInTown, city }) => {
  const { priceData, marketLabel } = marketData(prices);
  const { townData, statusLabel } = statusData(city);

  return (
    <StatusContainer>
      {showStatusInTown && (
        <StatusBlock>
          <Table
            data={townData}
            summaryLabel={statusLabel}
            summaryTotal={null}
            summaryMax={null}
            summaryTotalWarning={false}
            resetWarning={() => {}} // Provide an actual function if needed
          />
        </StatusBlock>
      )}

      <StatusBlock>
        <Table
          data={priceData}
          summaryLabel={marketLabel}
          summaryTotal={null}
          summaryMax={null}
          summaryTotalWarning={false}
          resetWarning={() => {}} // Provide an actual function if needed
        />
      </StatusBlock>
    </StatusContainer>
  );
};

export default CityStatus;
